module.exports = __webpack_public_path__ + "img/zanwushuj.16a2bd3b.png";